/**
 * SaveValidationError — thrown by a card edit form's save handler when
 * client-side validation fails (e.g. a required field is empty).
 *
 * The shared edit-state hook (`useActionEditState`) treats this distinctly
 * from a real save failure: it aborts the save and keeps the editor open
 * WITHOUT showing the generic "Failed to save changes" toast. The form is
 * responsible for surfacing actionable inline field-level errors instead.
 */
export class SaveValidationError extends Error {
  constructor(message = 'Validation failed') {
    super(message);
    this.name = 'SaveValidationError';
  }
}
